/**
 * Created by mongoose on 14/11/17.
 */
import React from "react";
import PropTypes from "prop-types";
import { Alert } from "react-bootstrap-3";
import { FormattedMessage, defineMessages } from "react-intl";

const messages = defineMessages({
  anErrorOcurred: {
    id: "app.form.anErrorOcurred",
    description: "An error occurred while saving text",
    defaultMessage: "An error occurred while saving.",
  },
  entityExists: {
    id: "app.form.entityExists",
    description: "An identifier with this name already exists. Please change indentifyer.",
    defaultMessage: "An identifier with this name already exists. Please change indentifyer.",
  },
});

function EntityErrorMessage({
  entityError: { code, operation, localMessage } = {},
}) {
  let errorMessage = <FormattedMessage {...messages.anErrorOcurred} />;

  switch (operation) {
    case "create":
    case "update":
      errorMessage = <FormattedMessage {...messages.anErrorOcurred} />;
      break;
    default:
  }

  switch (code) {
    case "CONFLICT":
      errorMessage = <FormattedMessage {...messages.entityExists} />;
      break;
    default:
      console.log("no error status");
  }
  return (
    <div>
      <Alert bsStyle="danger">
        <strong>{localMessage ? localMessage : errorMessage}</strong>
      </Alert>
    </div>
  );
}

EntityErrorMessage.propTypes = {
  entityError: PropTypes.object,
};

export default EntityErrorMessage;
